import type { NerriNavigationItem } from "./models/navigation-items.model";
import { FlagsmithFeatureFlagNavigationResolver } from "../flagsmith/providers/flagsmith-feature-flag-navigation.resolver";

export const MunicipalityAdminNavigationItems: NerriNavigationItem[] = [
    // TODO: Add when home page is done
    /* {
        id: "home",
        type: "group",
        children: [
            {
                id: "dashboard",
                title: "navigation.dashboard",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:layout-dashboard",
                link: "/dashboard"
            }
        ]
    },
    {
        type: "divider"
    },*/
    {
        id: "managements",
        type: "group",
        children: [
            {
                id: "properties",
                title: "navigation.places",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:maps-pin-1",
                link: "/dashboard/property"
            },
            {
                id: "owners",
                title: "navigation.owners",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:single-neutral-home",
                link: "/dashboard/owner"
            },
            {
                id: "system-channels",
                title: "navigation.system_channels",
                type: "basic",
                iconType: "svg",
                icon: "streamline-regular:archive-locker",
                link: "/dashboard/system-channel",
                hidden: FlagsmithFeatureFlagNavigationResolver,
                meta: {
                    featureKey: "system_channel_module"
                }
            },
            {
                id: "septage-measurement-visits",
                module: "septage_management",
                title: "navigation.septage_measurement_visits.section_title",
                type: "collapsable",
                iconType: "svg",
                icon: "streamline-regular:ruler",
                link: "/dashboard/septage-measurement-visit",
                children: [
                    {
                        id: "septage-measurement-visits-overview",
                        title: "navigation.septage_measurement_visits.overview",
                        type: "basic",
                        link: "/dashboard/septage-measurement-visit/overview"
                    },
                    {
                        id: "manage-septage-measurement-visits",
                        title: "navigation.septage_measurement_visits.manage",
                        type: "basic",
                        link: "/dashboard/septage-measurement-visit/manage"
                    },
                    {
                        id: "septage-measurement-visits-history",
                        title: "navigation.septage_measurement_visits.history",
                        type: "basic",
                        link: "/dashboard/septage-measurement-visit/history"
                    }
                ]
            },
            {
                id: "pumping-visits",
                module: "pumping_management",
                title: "navigation.pumping_visits.section_title",
                type: "collapsable",
                iconType: "svg",
                icon: "streamline-regular:gardening-watering-pipe",
                children: [
                    {
                        id: "pumping-visits-list",
                        title: "navigation.pumping_visits.overview",
                        type: "basic",
                        link: "/dashboard/pumping-visit/overview"
                    },
                    {
                        id: "manage-pumping-visits",
                        title: "navigation.pumping_visits.manage",
                        type: "basic",
                        link: "/dashboard/pumping-visit/manage"
                    },
                    {
                        id: "pumping-visits-list",
                        title: "navigation.pumping_visits.history",
                        type: "basic",
                        link: "/dashboard/pumping-visit/history"
                    }
                ]
            },
            {
                id: "maintenance-contracts",
                module: "maintenance_management",
                title: "navigation.maintenance_contracts.section_title",
                type: "collapsable",
                iconType: "svg",
                icon: "streamline-regular:common-file-text",
                link: "/dashboard/maintenance-contract",
                hidden: FlagsmithFeatureFlagNavigationResolver,
                meta: {
                    featureKey: "maintenance_contracts"
                },
                children: [
                    {
                        id: "maintenance-contracts-overview",
                        title: "navigation.maintenance_contracts.overview",
                        type: "basic",
                        link: "/dashboard/maintenance-contract/overview",
                        hidden: FlagsmithFeatureFlagNavigationResolver,
                        meta: {
                            featureKey: "maintenance_contracts_overview"
                        }
                    },
                    {
                        id: "maintenance-contracts-list",
                        title: "navigation.maintenance_contracts.current",
                        type: "basic",
                        link: "/dashboard/maintenance-contract/current",
                        hidden: FlagsmithFeatureFlagNavigationResolver,
                        meta: {
                            featureKey: "maintenance_contracts_current_list"
                        }
                    },
                    {
                        id: "maintenance-contracts-list-history",
                        title: "navigation.maintenance_contracts.history",
                        type: "basic",
                        link: "/dashboard/maintenance-contract/history"
                    }
                ]
            },
            {
                id: "maintenance-visits",
                module: "maintenance_management",
                title: "navigation.maintenance_visits.section_title",
                type: "collapsable",
                iconType: "svg",
                icon: "streamline-regular:tools-box",
                link: "/dashboard/maintenance-visit",
                children: [
                    {
                        id: "maintenance-visits-overview",
                        title: "navigation.maintenance_visits.overview",
                        type: "basic",
                        link: "/dashboard/maintenance-visit/overview",
                        hidden: FlagsmithFeatureFlagNavigationResolver,
                        meta: {
                            featureKey: "maintenance_visits_overview"
                        }
                    },
                    {
                        id: "maintenance-visits-list",
                        title: "navigation.maintenance_visits.current",
                        type: "basic",
                        link: "/dashboard/maintenance-visit/current",
                        hidden: FlagsmithFeatureFlagNavigationResolver,
                        meta: {
                            featureKey: "maintenance_visits_current_list"
                        }
                    },
                    {
                        id: "manage-maintenance-visits",
                        title: "navigation.maintenance_visits.manage",
                        type: "basic",
                        link: "/dashboard/maintenance-visit/manage"
                    },
                    {
                        id: "maintenance-visits-list-history",
                        title: "navigation.maintenance_visits.history",
                        type: "basic",
                        link: "/dashboard/maintenance-visit/history"
                    }
                ]
            },
            {
                id: "sanitary-report-visits",
                title: "navigation.sanitary_report_visits",
                type: "collapsable",
                iconType: "svg",
                icon: "streamline-regular:medical-files-medical-check",
                link: "/dashboard/sanitary-report-visit",
                hidden: FlagsmithFeatureFlagNavigationResolver,
                meta: {
                    featureKey: "sanitary_reports"
                },
                children: [
                    {
                        id: "sanitary-report-visits-list",
                        title: "navigation.sanitary_report_visits",
                        type: "basic",
                        link: "/dashboard/sanitary-report-visit"
                    },
                    {
                        id: "sanitary-report-visits-list",
                        title: "navigation.completed_sanitary_report_visits",
                        type: "basic",
                        link: "/dashboard/sanitary-report-visit/completed"
                    },
                    {
                        id: "sanitary-report-visits-list",
                        title: "navigation.incomplete_sanitary_report_visits",
                        type: "basic",
                        link: "/dashboard/sanitary-report-visit/incomplete"
                    }
                ]
            }
        ]
    },
    {
        type: "divider"
    },
    {
        id: "user",
        title: "navigation.users",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:multi-neutral-2",
        link: "/dashboard/user"
    },
    {
        id: "settings",
        title: "navigation.settings",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:cog-double-2",
        link: "/dashboard/setting",
        hidden: FlagsmithFeatureFlagNavigationResolver,
        meta: {
            featureKey: "municipality_settings_access"
        }
    }
];
